import { render, staticRenderFns } from "./depositFreeDetail.vue?vue&type=template&id=e1a286d6&scoped=true"
import script from "./depositFreeDetail.vue?vue&type=script&lang=js"
export * from "./depositFreeDetail.vue?vue&type=script&lang=js"
import style0 from "./depositFreeDetail.vue?vue&type=style&index=0&id=e1a286d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1a286d6",
  null
  
)

export default component.exports